module.exports = __webpack_public_path__ + "assets/img/title1.dc7ff2d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./website/assets/title1.jpeg
// module id = s5Kw
// module chunks = 50